// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductContext, ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import React, { useState } from "react";

interface OwnProps {
    product: any;
}

const SearchAutoCompleteProductAction: React.FC<OwnProps> = ({ product, children }) => {
    const [productInfoState, setProductInfoState] = useState({
        productId: product.id,
        qtyOrdered: Math.max(Number(product.properties["quantity"]), 1),
        unitOfMeasure: "",
        productDetailPath: product.url,
    });

    const onQtyChange = (qty: number) => {
        setProductInfoState({
            ...productInfoState,
            qtyOrdered: qty,
        });
    };

    const productContext: ProductContextModel = {
        product: {
            ...product,
            canAddToCart: true,
        },
        productInfo: productInfoState,
        onQtyOrderedChanged: onQtyChange,
    };

    return <ProductContext.Provider value={productContext}>{children}</ProductContext.Provider>;
};

export default SearchAutoCompleteProductAction;
